import { Card, CardBody, Flex, Image } from '@chakra-ui/react';
import Checkbox from '../checkbox';
import Text from '../text';

interface CustomSelectBoxProps {
    label?: string;
    logo?: string;
    darkLogo?: string;
    onChange: (checked: boolean) => void;
    isChecked?: boolean;
    isDisabled?: boolean;
    disabledText: string;
    colorMode: string | undefined;
}

function CustomSelectBox(props: CustomSelectBoxProps) {
    const { label, logo, darkLogo, isChecked, isDisabled, disabledText, onChange, colorMode } = props;

    return (
        <Card
            shadow="none"
            border="1px"
            borderColor={colorMode == 'light' ? 'border' : 'transparent'}
            borderRadius={10}
            bg={colorMode == 'light' ? '' : 'alphaWhite003'}
            onClick={() => !isDisabled && onChange(true)}
            cursor={isDisabled ? 'not-allowed' : 'pointer'}
            opacity={isDisabled ? 0.4 : 1}
        >
            <CardBody py="0" px="24px">
                <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    h="65px"
                >
                    {label && !logo && !darkLogo && <Text>{label}</Text>}
                    {logo && darkLogo && (
                        <Image
                            h="50%"
                            maxW="40%"
                            src={colorMode == 'light' ? logo : darkLogo}
                        />
                    )}
                    {isDisabled && (
                        <Text>{disabledText}</Text>
                    )

                    }
                    {!isDisabled && (
                        <Checkbox
                            isChecked={isChecked}
                            isDisabled={isDisabled}
                            onChange={(e) =>
                                !isDisabled && onChange(e.currentTarget.checked)
                            }
                        />
                    )}
                </Flex>
            </CardBody>
        </Card>
    );
}

export default CustomSelectBox;
